module.exports = __webpack_public_path__ + "static/media/google.58fa841d.svg";